export default {
  billing_rule: {
    name: '充电费率',
    prop: {
      name: '费率名称',
      special_billing_rule_name: '周期费率名称',
      service_provider: '运营商',
      service_provider_id: '运营商',
      price: '价格',
      pricings: '分时费率',
      energy_loss: '信号上传频率',
      description: '备注',
      created_at: '创建时间',
      updated_at: '更新时间',
      note: '备注',
      flat_price: '平价',
      peak_price: '峰价',
      valley_price: '谷价',
      sharp_peak_price: '尖价',
      ev_charging_stations: '电站',
      charge_point: '电桩',
      group: '集团优惠',
      time_division_type: '费率时段类型',
      allow_half_hour_step: '半小时费率'
    },
    time_types: {
      sharp_peak: '尖',
      peak: '峰',
      flat: '平',
      valley: '谷',
      unknown: '普'
    },
    time_division_types: {
      four_division: '4费率',
      eight_division: '8费率'
    },
    allow_half_hour_steps: {
      enable: '支持半小时',
      disable: '禁用半小时'
    },
    allow_half_hour_step_tip: '仅有部分桩支持半小时，如果在不支持的桩上设置会导致桩不计费问题，谨慎使用',
    placeholder: {
      search_keyword: '费率名称/备注',
      input_name: '某充电站费率',
      input_note: 'App不可见'
    },
    validates: {
      invalid_pricings: '时间或价格设置有误'
    },
    evcs_station_billing_rule: {
      evcs_billing_rule: '第三方原费率',
      custom_billing_rule: '自定义费率',
      setting: '设置',
      service_amount: '服务费',
      elec_amount: '电费',
      evcs_billing_rule_btn_label: '(推荐) 支持基于对方平台的费率，按指定金额 或者 比例调整单价',
      custom_billing_rule_btn_label: '(不推荐) 需要确定对方的分时费率信息粒度为半小时才能设置，需要实际充电并查看订单明细',
      money_increase: '按指定金额',
      percentage_increase: '按百分比',
      evcs_service_price_money_increase: '每度电上调的服务费',
      evcs_elec_price_money_increase: '每度电上调的充电费',
      evcs_service_price_percent_increase: '服务费单价上浮',
      evcs_elec_price_percent_increase: '电费单价上浮',
      dialog_title: '充电单价上浮调整'
    },
    group_titles: {
      base: '基本信息',
      prices: '分时费率'
    },
    labels: {
      common_stations: '常规费率的充电站',
      common_charge_points: '常规费率的桩',
      special_stations: '周期费率的充电站',
      groups: '费率的集团优惠',
      vip_stations: '会员费率的充电站',
      group_stations: '社群费率的充电站',
      begin_time: '开始时间',
      charge_price: '电价',
      service_price: '服务价',
      total_price: '总价',
      time_type: '时间类型'
    },
    btn: {
      debug_billing_rule: '调试费率',
      clone: '克隆充电费率',
      insert_before_row: '向上插入行',
      insert_after_row: '向下插入行'
    },
    list_tabs: {
      all: '全部',
      station_in_used: '站常规费率',
      charge_point_in_used: '桩常规费率',
      special_billing_rule: '站周期费率',
      group_in_used: '集团费率',
      vip_station_in_used: '会员电站费率',
      not_used: '未使用'
    }
  }
}
